import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './HamburgerIcon.module.css';

const HamburgerIcon = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className={styles.hamburgerContainer}>
      <div 
        className={`${styles.hamburgerMenu} ${isMenuOpen ? styles.active : ''}`} 
        onClick={toggleMenu}
      ></div>
      
      {isMenuOpen && (
        <div className={styles.dropdownMenu}>
          <ul className={styles.dropdownList}>
            <li><Link to="/" className={styles.dropdownLink} onClick={() => setIsMenuOpen(false)}>HOME</Link></li>
            <li><Link to="/about" className={styles.dropdownLink} onClick={() => setIsMenuOpen(false)}>ABOUT</Link></li>
            <li><Link to="/team" className={styles.teamDropdownLink} style={{ paddingLeft: 32 }} onClick={() => setIsMenuOpen(false)}>TEAM</Link></li>
            <li><Link to="/services" className={styles.dropdownLink} onClick={() => setIsMenuOpen(false)}>SERVICES</Link></li>
            <li><Link to="/work" className={styles.dropdownLink} onClick={() => setIsMenuOpen(false)}>WORK</Link></li>
            <li><Link to="/join" className={styles.dropdownLink} onClick={() => setIsMenuOpen(false)}>JOIN</Link></li>
            <li><Link to="/connect" className={styles.dropdownLink} onClick={() => setIsMenuOpen(false)}>CONNECT</Link></li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default HamburgerIcon; 